import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Mobiilisovellukset — Frisbeegolf' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Mobiilisovellukset"
			intro="Tuloskorttisovellukset, kartat ja muut hyödylliset apit."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
